import { Header as AccordionHeader, Trigger as AccordionTrigger } from "@radix-ui/react-accordion";
import { type ComponentProps } from "react";

import { cn } from "../../utils";

export const Trigger = ({ ref, className, children, ...props }: ComponentProps<typeof AccordionTrigger>) => (
  <AccordionHeader className="flex" asChild>
    <AccordionTrigger ref={ref} asChild {...props}>
      <div className={cn("flex flex-1 items-center transition-all", "[&[data-state=open]>svg]:rotate-180", className)}>
        {children}
      </div>
    </AccordionTrigger>
  </AccordionHeader>
);
Trigger.displayName = AccordionTrigger.displayName;

export default Trigger;
